(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  $(window).load(function(){
    if($("#varid").html()== "")
    {
      var alt = $.trim($("a.swatchlink img").first().attr('alt'));
      alt = alt.replace(" ","_");
      $("a.swatchlink img").first().addClass("selectedswatch");
      $("li.color"+alt).show();
    }
    else{
      var varid = $("#varid").html();
      var alt = $.trim($("a#"+varid+" img").attr('alt'));
      alt = alt.replace(" ","_");
      $("li.color"+alt).show();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
